// import React, { useEffect, useState, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import { getCounsellor, counsellorsBookedByMe } from "../api/api";
// import { environment } from "../../environments/environments";
// import "./HomeConsultant.css"; // CSS styles here
// import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";

// const HomeConsultant = () => {
//   const navigate = useNavigate();
//   const [counsellors, setCounsellors] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [bookings, setBookings] = useState([]);

//   const fetchCounsellors = async () => {
//     try {
//       const res = await getCounsellor();
//       setCounsellors(res?.counsellors || []);
//     } catch (err) {
//       console.error("Error fetching counsellors", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchBookings = async () => {
//     const userData = localStorage.getItem("currentUser");
//     const parsedUser = JSON.parse(userData);
//     const userId = parsedUser?.id || parsedUser?._id;
//     try {
//       const res = await counsellorsBookedByMe({ user_id: userId });
//       setBookings(res?.data || []);
//     } catch (err) {
//       console.error("Error fetching bookings", err);
//     }
//   };

//   useEffect(() => {
//     fetchCounsellors();
//     fetchBookings();
//   }, []);

//   const formatRole = (role) => {
//     const roles = {
//       match_success_advisor: "Match Success Advisor",
//       connection_curator: "Connection Curator",
//       match_making_consultant: "Match Making Consultant",
//       relationship_success_coach: "Relationship Success Coach",
//     };
//     return roles[role] || role?.replace(/_/g, " ");
//   };

//   // const handleBooking = (item) => {
//   //   const userData = localStorage.getItem("currentUser");
//   //   const parsedUser = JSON.parse(userData);
//   //   const userId = parsedUser?.id || parsedUser?._id;
//   //   const url = `https://connecttovow.com/book-a-slot/${
//   //     item?.id || item?._id
//   //   }/${userId}`;
//   //   navigate("/ConsultPaymentWebView", { state: { paymentUrl: url } });
//   // };

//   const handleBooking = (item) => {
//     const userData = JSON.parse(localStorage.getItem("currentUser"));
//     const userId = userData?.id || userData?._id;
//     const url = `https://backend.connecttovow.com/book-a-slot/${item.id || item._id
//       }/${userId}`;
//     navigate("/Sidebar/ConsultPaymentWebView", { state: { paymentUrl: url } });
//   };

//   const openChat = (item) => {
//     navigate("/Sidebar/ChatConsult", { state: { item } });
//   };

//   if (loading) {
//     return <div className="loader"></div>;
//   }

//   return (
//     <div className="consultant-main">
//       <div className="consultant-container">
//         {counsellors.map((item) => {
//           const imageUrl = `${environment.url}/uploads/counsellors/${item?.image}`;
//           const isBooked = bookings.some((b) => b?.counsellor_id === item?.id);

//           const stars = Array.from({ length: 5 }, (_, i) => {
//             const full = Math.floor(item?.average_rating || 0);
//             const half = (item?.average_rating || 0) - i >= 0.5 && i >= full;
//             return i < full ? (
//               <FaStar key={i} className="star full" />
//             ) : half ? (
//               <FaStarHalfAlt key={i} className="star half" />
//             ) : (
//               <FaRegStar key={i} className="star empty" />
//             );
//           });

//           return (
//             <div className="consultant-card" key={item?.id}>
//               <img src={imageUrl} alt="Consultant" className="consultant-img" />
//               <div className="consultant-details">
//                 {/* <div className="stars">{stars}</div> */}
//                 {/* <div className="stars">
//                 {stars.map((star, i) => (
//                   <span key={i} className="star-wrapper">
//                     {star}
//                   </span>
//                 ))}
//               </div> */}

//                 <h3>{item?.name}</h3>
//                 <p>{formatRole(item?.role)}</p>
//                 <button
//                   className={isBooked ? "chat-btn" : "book-btn"}
//                   onClick={() =>
//                     isBooked ? openChat(item) : handleBooking(item)
//                   }
//                 >
//                   {isBooked ? "Chat Now" : "Book Now"}
//                 </button>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default HomeConsultant;

import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { getCounsellor, counsellorsBookedByMe } from "../api/api";
import { environment } from "../../environments/environments";
import "./HomeConsultant.css"; // CSS styles here
import { FaStar, FaStarHalfAlt, FaRegStar, FaUserTimes } from "react-icons/fa";

const HomeConsultant = () => {
  const navigate = useNavigate();
  const [counsellors, setCounsellors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [bookings, setBookings] = useState([]);

  const fetchCounsellors = async () => {
    try {
      const res = await getCounsellor();
      setCounsellors(res?.counsellors || []);
    } catch (err) {
      console.error("Error fetching counsellors", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchBookings = async () => {
    const userData = localStorage.getItem("currentUser");
    const parsedUser = JSON.parse(userData);
    const userId = parsedUser?.id || parsedUser?._id;
    try {
      const res = await counsellorsBookedByMe({ user_id: userId });
      setBookings(res?.data || []);
    } catch (err) {
      console.error("Error fetching bookings", err);
    }
  };

  useEffect(() => {
    fetchCounsellors();
    fetchBookings();
  }, []);

  const formatRole = (role) => {
    const roles = {
      match_success_advisor: "Match Success Advisor",
      connection_curator: "Connection Curator",
      match_making_consultant: "Match Making Consultant",
      relationship_success_coach: "Relationship Success Coach",
    };
    return roles[role] || role?.replace(/_/g, " ");
  };

  // const handleBooking = (item) => {
  //   const userData = localStorage.getItem("currentUser");
  //   const parsedUser = JSON.parse(userData);
  //   const userId = parsedUser?.id || parsedUser?._id;
  //   const url = `https://connecttovow.com/book-a-slot/${
  //     item?.id || item?._id
  //   }/${userId}`;
  //   navigate("/ConsultPaymentWebView", { state: { paymentUrl: url } });
  // };

  const handleBooking = (item) => {
    const userData = JSON.parse(localStorage.getItem("currentUser"));
    const userId = userData?.id || userData?._id;
    const url = `https://backend.connecttovow.com/book-a-slot/${
      item.id || item._id
    }/${userId}`;
    navigate("/Sidebar/ConsultPaymentWebView", { state: { paymentUrl: url } });
  };

  const openChat = (item) => {
    navigate("/Sidebar/ChatConsult", { state: { item } });
  };

  if (loading) {
    return <div className="loader"></div>;
  }

  return (
    <div className="consultant-main">
      <div className="consultant-container">
        {counsellors?.length > 0 ? (
          counsellors?.slice(0, 5).map((item) => {
            const imageUrl = `${environment.url}/uploads/counsellors/${item?.image}`;
            const isBooked = bookings.some(
              (b) => b?.counsellor_id === item?.id
            );

            const stars = Array.from({ length: 5 }, (_, i) => {
              const full = Math.floor(item?.average_rating || 0);
              const half = (item?.average_rating || 0) - i >= 0.5 && i >= full;
              return i < full ? (
                <FaStar key={i} className="star full" />
              ) : half ? (
                <FaStarHalfAlt key={i} className="star half" />
              ) : (
                <FaRegStar key={i} className="star empty" />
              );
            });

            return (
              <div className="consultant-card" key={item?.id}>
                <img
                  src={imageUrl}
                  alt="Consultant"
                  className="consultant-img"
                />
                <div className="consultant-details">
                  {/* <div className="stars">{stars}</div> */}
                  {/* <div className="stars">
                {stars.map((star, i) => (
                  <span key={i} className="star-wrapper">
                    {star}
                  </span>
                ))}
              </div> */}

                  <h3>{item?.name}</h3>
                  <p>{formatRole(item?.role)}</p>
                  <button
                    className={isBooked ? "chat-btn" : "book-btn"}
                    onClick={() =>
                      isBooked ? openChat(item) : handleBooking(item)
                    }
                  >
                    {isBooked ? "Chat Now" : "Book Now"}
                  </button>
                </div>
              </div>
            );
          })
        ) : (
          <div className="icon-text">
            <FaUserTimes
              size={60}
              color={environment?.Coral_Red}
              className="iconss"
            />
            <h3>Currently no Counsellor available</h3>
          </div>
        )}
      </div>
    </div>
  );
};

export default HomeConsultant;
